import { render, staticRenderFns } from "./somos.vue?vue&type=template&id=7248db55&scoped=true&"
var script = {}
import style0 from "./somos.vue?vue&type=style&index=0&id=7248db55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7248db55",
  null
  
)

export default component.exports